import React, { Component, Fragment } from "react";
import { utils } from "../common/utils";
import { withTranslation } from 'react-i18next';
import ExtendedLink  from "./ExtendedLink";
import Image from "./Image";
import CurrencyFormat from './CurrencyFormat';
import LoyaltyPointsPriceSwitch from "./LoyaltyPointsPriceSwitch";

class MobileCartLine extends Component {


  render() {
      const { t, line, isReadOnly, settings, user } = this.props;
    if (!line) return <div />;
    const { product } = line;
    const productLink = `/products/${product.id}`;

    //let quantityControl = this.state.quantity;
      let quantityControl = line.quantity;
      if (!isReadOnly) {
          // allow edit quantity
          const quantityOptions = [...Array(10)].map((x, i) => (
              <option key={i + 1} value={i + 1}>
                  {i + 1}
              </option>
          ));
          quantityControl = (
              <div className="count-input form-group row dropdown-product-details mobile-product-details">
                  <select
                      className="form-control form-control-sm col-4"
                      value={line.quantity}
                      onChange={this.props.onQuantityChange} >
                      {quantityOptions}
                  </select>
                  <span className='col-8 mt-2'>{" x "} <CurrencyFormat value={line.isLoyaltyPointsUsed ? 0 : line.specialPrice} settings={settings} />  =  <CurrencyFormat value={this.props.totalQuantityPrice} settings={settings} /> </span>
                  {(settings.isLoyaltyProgramFeatureEnabled && line.isPromo === false && user && user.isAuthenticated === true && product.loyaltyPoints > 0) &&
                      <div className="col-8" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderTop: '1px solid #e9ecef', marginTop: '6px', paddingTop: '6px' }}>
                          <small style={{ color: '#6c757d', fontWeight: '500' }}>{t("PayWithLoyaltyPoints")}</small>
                          <LoyaltyPointsPriceSwitch totalLoyaltyPoints={product.loyaltyPoints * line.quantity} isLoyaltyPointsUsed={line.isLoyaltyPointsUsed}
                              canPayWithLoyaltyPoints={this.props.canPayWithLoyaltyPoints} onTogglePayWithLoyaltyPoints={this.props.onTogglePayWithLoyaltyPoints} isReadOnly={isReadOnly} as="span"
                              style={{ display: 'inline-flex', alignItems: 'center' }} />
                      </div>
                  }
              </div>
          );
      } else {
          quantityControl = (<span className="dropdown-product-details">
              {line.quantity} x <CurrencyFormat value={line.isLoyaltyPointsUsed ? 0 : line.specialPrice} settings={settings} /> 
          </span>);
      }

      const actionColumn = isReadOnly ? <Fragment /> : (
          <button onClick={this.props.onRemoveLine} className="dropdown-product-remove btn btn-link"
              title={t("Remove item")}>
              <i className="icon-cross" />
          </button>
                                                      );


      return (
          <div className="dropdown-product-item">
              {actionColumn}
              <ExtendedLink to={productLink} className="dropdown-product-thumb mobile-product-thumb">
                  <Image src={product.thumbnail ? product.thumbnail : "img/no-image.jpg"}
                      fallbackSrc="img/no-image.jpg" alt={product.title} />
              </ExtendedLink>
              <div className="dropdown-product-info">
                  <ExtendedLink to={productLink} className="dropdown-product-title">
                      {product.title}
                  </ExtendedLink>
                  {quantityControl} 
              </div>
          </div>
          );

  }
}

export default withTranslation()(MobileCartLine);
